<div style="display:grid; grid-template-columns:1fr 40px;">

	<ol class="breadcrumb" style="overflow:hidden;">
		<li class="breadcrumb-item">
			<button id="up-path" class="breadcrumb-button" mat-button (click)='goUp()' title="Go Up One Level">
				<i class='fa-solid fa-arrow-up-left'></i>
			</button>
		</li>
		@for(breadcrumb of breadcrumbs(); track $index; let i = $index){
		<li [class]="getBreadcrumbClasses(i)">

			@if(breadcrumb.menu && breadcrumb.menu.length > 0){
			<mat-menu #appMenu="matMenu">
				@for (menuItem of breadcrumb.menu; track $index) {
				<button mat-menu-item [routerLink]="menuItem.path" class='breadcrumb-menu-item' [class.selected-menu-item]='isMenuItemSelected(breadcrumb, menuItem)'>
					{{menuItem.label}}
				</button>
				}
			</mat-menu>

			<button class='breadcrumb-button' mat-button [matMenuTriggerFor]="appMenu">
				{{breadcrumb.label}}
				<i class="fa-solid fa-caret-down"></i>
			</button>
			}
			@else{
			<button mat-button disabled>
				{{breadcrumb.label}}
			</button>
			}
		</li>
		}
	</ol>


	<button class='breadcrumb-menu-item' style='padding:0; border:none; background:transparent; font-size:1.1em; margin-bottom:10px;' (click)='toggleNavTabs()'>

		@if(layoutService.showNavTabsVisibility()=== "Auto"){
		<i class='fa-regular' [class.fa-rectangle-landscape]="!layoutService.showNavTabs()" [class.fa-folder]="layoutService.showNavTabs()" style='color:#AAA;'></i>
		}
		@else{
		<i class='fa-regular' [class.fa-rectangle-landscape]="!layoutService.showNavTabs()" [class.fa-folder]="layoutService.showNavTabs()" style='color:#555;'></i>
		}

	</button>

</div>

@if(layoutService.showNavTabs()){

<nav mat-tab-nav-bar class="navigation-tabs">
	@for (tab of tabs(); track $index) {
	<a mat-tab-link [routerLink]="tab.path" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
		{{ tab.label }}
	</a>
	}
</nav>

}